import { handleActions, createAction } from 'redux-actions';
import { get } from 'lodash';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_REDASH_LINK_PROXY',
    'FETCH_REDASH_LINK_PROXY_SUCCESS',
    'FETCH_EMBEDDED_LINK',
    'FETCH_EMBEDDED_LINK_SUCCESS',
], 'EMBEDDED_LINK');

export const fetchRedashLinkProxy = createAction(actions.FETCH_REDASH_LINK_PROXY, params => params);
export const fetchRedashLinkProxySuccess = createAction(actions.FETCH_REDASH_LINK_PROXY_SUCCESS, data => data);
export const fetchEmbeddedLink = createAction(actions.FETCH_EMBEDDED_LINK, params => params);
export const fetchEmbeddedLinkSuccess = createAction(actions.FETCH_EMBEDDED_LINK_SUCCESS, data => data);

const initialState = {
    embeddedLink: {
        frameUrl: null,
        platform: null
    }
};

export default handleActions({
    [actions.FETCH_REDASH_LINK_PROXY_SUCCESS]: (state, action) => update(state, {
        embeddedLink: {
            $merge: {
                frameUrl: get(action.payload, 'data.getProxiedRedashDashboard.frameUrl')
            }
        }
    }),
    [actions.FETCH_EMBEDDED_LINK_SUCCESS]: (state, action) => update(state, {
        embeddedLink: {
            $merge: {
                frameUrl: get(action.payload, 'embeddedLink.frameUrl')
            }
        }
    }),

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })
}, initialState);



// WEBPACK FOOTER //
// ./src/services/embeddedLinks/duck.js